import React from "react";

const LoaderJobBoardDetails = () => {
  return (
    <div className="bg-green-200 h-screen px-5 pt-20">
      <div className="rounded-xl bg-white p-10 h-[600px] ">
        <div class="h-5.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px] mb-8"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 mb-6"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 mb-6"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[780px] mb-6"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[700px] mb-6"></div>
        <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[760px]"></div>
      </div>
    </div>
  );
};

export default LoaderJobBoardDetails;
